import Vue from 'vue';
import App from './App.vue';
import router from './router';
import axios from '../src/api/request';
import ElementUI from 'element-ui';
import 'quill/dist/quill.core.css';
import 'element-ui/lib/theme-chalk/index.css';
import { i18n } from './i18n/index' //国际化
import { Converter } from 'opencc-js'

import message from './utils/message.js';

// 创建两个转换器实例
const toTraditionalPromise = Converter({ from: 'cn', to: 'tw' })  // 简体转繁体
const toSimplifiedPromise = Converter({ from: 'tw', to: 'cn' })  // 繁体转简体

// 定义全局指令
Vue.directive('transform-chinese', {
  async bind(el, binding) {
    await updateText(el, binding)
  },
  async update(el, binding) {
    await updateText(el, binding)
  }
})
// 更新文本函数
async function updateText(el, binding) {
  const locale = localStorage.getItem('locale')
  const text = binding.value || el.textContent
  
  if (locale === 'tc') {
    // 转为繁体
    const converter = await toTraditionalPromise
    el.textContent = converter(text)
  } else {
    // 转为简体
    const converter = await toSimplifiedPromise
    el.textContent = converter(text)
  }
}

// 监听 locale 变化
window.addEventListener('storage', async (event) => {
  if (event.key === 'locale') {
    // 找到所有使用 v-transform-chinese 指令的元素并更新它们
    const elements = document.querySelectorAll('[v-transform-chinese]')
    for (const el of elements) {
      const text = el.getAttribute('v-transform-chinese') || el.textContent
      await updateText(el, { value: text })
    }
  }
})

// 添加全局方法用于改变语言
Vue.prototype.$setLocale = async function(locale) {
  localStorage.setItem('locale', locale)
  // 手动触发更新，因为 storage 事件只在其他标签页触发
  window.dispatchEvent(new StorageEvent('storage', {
    key: 'locale',
    newValue: locale
  }))
}
Vue.prototype.$messages = message;
Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.use(ElementUI);
new Vue({
  i18n,
  router,
  render: (h) => h(App),
}).$mount('#app');
